var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"保费设置"}},[(_vm.originData.length !== 0)?_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm,"labelWidth":"160px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }